import { updateCheckDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: updateCheckDepositSlice, asyncAction: updateCheckDepositAction } = createAsyncSlice(
  'updateCheckDepositSlice',
  updateCheckDepositAsync
);
